import { useDispatch } from "react-redux"

import { bindActionCreators } from "@reduxjs/toolkit"

import { actions } from "./projectsSlice"

export function useProjectsActions() {
  const dispatch = useDispatch()
  return bindActionCreators(actions, dispatch)
}
